import React, { ReactNode } from "react";
import PageHeader from "@/components/PageHeader";
import clsx from "clsx";

type Params = { children: ReactNode; header?: ReactNode; className?: string };
export default function PageRoot({ children, header, className }: Params) {
  return (
    <div className="overflow-y-scroll flex flex-col">
      <div>{header && <PageHeader header={header} />}</div>
      <div className={clsx("grow", className)}>{children}</div>
    </div>
  );
}
